/**
 * Ordena os relatórios:
 * - Primeiro, coloca os revisados (reviewed: true) no topo.
 * - Depois, dentro de cada grupo, ordena por data mais recente primeiro.
 *
 * @param {Array} reports - Lista de relatórios.
 * @returns {Array} - Nova lista de relatórios ordenados.
 */
export const sortReports = (reports) =>
  reports.slice().sort((a, b) => {
    if (a.reviewed !== b.reviewed) {
      return a.reviewed ? -1 : 1;
    }
    return b.rawDate.getTime() - a.rawDate.getTime();
  });
